import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbAccordionModule, NgbAlertModule, NgbDatepickerModule, NgbDropdownModule, NgbModalModule, NgbNavModule, NgbPaginationModule, NgbPopoverModule, NgbProgressbarModule, NgbTimepickerModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { ConfirmationPopoverModule } from 'angular-confirmation-popover';
import { PrettyJsonModule } from 'angular2-prettyjson';
import { ControlBarTimeSelectorComponent } from 'src/app/control-bar/control-bar-time-selector/control-bar-time-selector.component';
import { ExtractorGroupEditComponent } from 'src/app/data-types/event-modeler/extractor-group-edit/extractor-group-edit.component';
import { DummyComponent } from 'src/app/dummy/dummy.component';
import { ImportComponent } from 'src/app/import-export/import.component';
import { RateLimitConfirmModalComponent } from 'src/app/shared/rate-limit-confirm-modal/rate-limit-confirm-modal.component';
import { SurroundingEventsComponent } from 'src/app/result-table/surrounding-events/surrounding-events.component';
import { MaskingRuleEditComponent } from 'src/app/security/masking-rule/masking-rule-edit/masking-rule-edit.component';
import { TimeoutLoaderComponent } from 'src/app/shared/timeout-loader/timeout-loader.component';
import { NotificationAnimationType, NotificationsService, SimpleNotificationsModule } from 'bowman-angular2-notifications';
import { BowmanCommonsModule } from 'bowman-commons';
import { ModalModule } from 'src/lib/modal';
import { NgBusyModule } from 'ng-busy';
import { ContextMenuModule } from 'ngx-contextmenu';
import { FileSaverModule } from 'ngx-filesaver';
import { ControlBarTypeSelectorComponent } from '../control-bar-type-selector/control-bar-type-selector.component';
import { ControlBarSelectComponent } from '../control-bar/control-bar-select/control-bar-select.component';
import { TimestampFormatPipe } from '../timestamp-format.pipe';
import { DrawflowGraphComponent } from '../drawflow-graph/drawflow-graph.component';
import { MarkdownModule } from 'ngx-markdown';
import { AngularMarkdownEditorModule } from 'angular-markdown-editor';

@NgModule({
  declarations: [
    ImportComponent,
    ControlBarTimeSelectorComponent,
    ControlBarTypeSelectorComponent,
    ControlBarSelectComponent,
    ExtractorGroupEditComponent,
    MaskingRuleEditComponent,
    SurroundingEventsComponent,
    RateLimitConfirmModalComponent,
    TimeoutLoaderComponent,
    DummyComponent,
    DrawflowGraphComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BowmanCommonsModule,
    NgSelectModule,
    NgBusyModule,
    NgbAlertModule,
    NgbPopoverModule,
    NgbDatepickerModule,
    NgbTimepickerModule,
    NgbTooltipModule,
    NgbModalModule,
    NgbDropdownModule,
    NgbPaginationModule,
    NgbProgressbarModule,
    FileSaverModule,
    ModalModule,
    PrettyJsonModule,
    ConfirmationPopoverModule.forRoot(),
    ContextMenuModule.forRoot({
      useBootstrap4: true
    }),
    SimpleNotificationsModule.forRoot({
      position: ["bottom", "right"],
      timeOut: 4000,
      showProgressBar: true,
      pauseOnHover: true,
      lastOnBottom: true,
      animate: NotificationAnimationType.FromBottom
    }),
    NgbAccordionModule,
    AngularMarkdownEditorModule.forRoot({ iconlibrary: 'fa' }),
    MarkdownModule.forRoot(),
  ],
  providers: [
    NotificationsService,
    DatePipe,
    DecimalPipe,
    TimestampFormatPipe
  ],
  exports: [
    SimpleNotificationsModule,
    FormsModule,
    NgSelectModule,
    NgBusyModule,
    NgbAlertModule,
    NgbPopoverModule,
    NgbDatepickerModule,
    NgbAccordionModule,
    NgbTimepickerModule,
    NgbTooltipModule,
    NgbModalModule,
    NgbDropdownModule,
    NgbNavModule,
    ConfirmationPopoverModule,
    FileSaverModule,
    ReactiveFormsModule,
    ControlBarTimeSelectorComponent,
    ControlBarTypeSelectorComponent,
    ControlBarSelectComponent,
    NgbPaginationModule,
    ExtractorGroupEditComponent,
    MaskingRuleEditComponent,
    ModalModule,
    PrettyJsonModule,
    ContextMenuModule,
    NgbAccordionModule,
    NgbProgressbarModule,
    TimeoutLoaderComponent,
    BowmanCommonsModule,
    SurroundingEventsComponent,
    DrawflowGraphComponent,
    AngularMarkdownEditorModule,
    MarkdownModule
  ],

  entryComponents: [
    ImportComponent,
    ExtractorGroupEditComponent,
    MaskingRuleEditComponent,
    SurroundingEventsComponent,
    RateLimitConfirmModalComponent
  ]
})
export class SharedModule { }
